import api from "../../ApiConfig";
import { Apis } from "../../../config";
import { NotificationManager } from "react-notifications";

const getAllCustomerList = async () => {
  try {
    let result = await api.get(Apis.GetAllCustomerDetails);
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const searchAllCustomers = async ({ query, customerId }) => {
  try {
    let url = `${Apis.GetCustomerBySearch}?`;

    if (customerId) {
      url += `customerId=${customerId}`;
    } else if (query) {
      url += `query=${query}`;
    }

    const result = await api.get(url);

    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getCustomerDeleteById = async (id) => {
  try {
    let result = await api.delete(Apis.GetCustomerDeleteById, {
      params: { id },
    });
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getCustomerUpdate = async (data) => {
  try {
    let result = await api.post(Apis.GetCustomerUpdateDetails, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// Function to reset the password
const resetPassword = async (email, phone) => {
  try {
    // Post the data correctly with email and phone as password
    let result = await api.post(Apis.Resetpassword, { email, password: phone });

    // Check for errors in the result
    if (result.data.errors) {
      NotificationManager.error(result.data.errors.join(", "), "Error"); // Join errors for better readability
      return null;
    }
    return result.data; // Return the successful result data
  } catch (error) {
    console.log(error); // Log the error for debugging
    NotificationManager.error(
      "An error occurred while resetting the password",
      "Error"
    ); // Notify user of the error
    return null;
  }
};

const getCustomerCount = async () => {
  try {
    let result = await api.get(Apis.GetAllCustomerCount);
    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }
    return result.data; // Assuming the API response contains a `count` property
  } catch (error) {
    console.log(error);
    return null;
  }
};

const getAdminUserLogin = async (data) => {
  try {
    let result = await api.post(Apis.GetAdminUserLogin, data);
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default {
  getAllCustomerList,
  searchAllCustomers,
  getCustomerUpdate,
  getCustomerDeleteById,
  resetPassword,
  getCustomerCount,
  getAdminUserLogin,
};



// WEBPACK FOOTER //
// ./src/components/services/GetCustomerDetails/index.js